<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import singleActionsMixin from '../mixins/singleActions'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'RechargeRecordList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, singleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
    type: String,
    data: Object,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'billing_payments',
        getParams: this.getParam,
      }),
    }
  },
  computed: {
    groupActions () {
      const arr = []
      let obj = {}
      if (this.type && this.type === 'manager') {
        obj = {
          label: this.$t('scope.text_841'),
          action: () => {
            this.createDialog('OfflineRechargeAmountDialog', {
              onManager: this.onManager,
              refresh: this.refresh,
              data: this.data,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        }
        arr.push(obj)
      }
      return arr
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams) }
      return ret
    },
  },
}
</script>
